import { isNull } from 'lodash';
import type { Share } from '@frameio/graphql-client/generated';

type GetIsShareExpiredArgs = Pick<Share, 'expiration' | 'expiresIn'>;

type GetIsShareVisibleArgs = GetIsShareExpiredArgs & Pick<Share, 'enabled'>;

export function getIsShareExpired({
  expiration,
  expiresIn,
}: GetIsShareExpiredArgs) {
  return !isNull(expiresIn) && expiresIn <= 0 && Boolean(expiration);
}

export function getIsShareVisible({
  enabled,
  expiration,
  expiresIn,
}: GetIsShareVisibleArgs) {
  return !getIsShareExpired({ expiration, expiresIn }) && enabled;
}
